import React from "react";
import { Grid2, Stack, Typography } from "@mui/material";

type ProjectCardProps = {
  title: string;
  descriptions: string[];
  index: number;
};

export const ServicesCard: React.FC<ProjectCardProps> = (props) => {
  const { title, descriptions, index } = props;

  return (
    <Grid2 size={{ lg: 1, md: 2, xs: 4 }}>
      <Stack
        width={1}
        height={1}
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        gap={2}
        border={2}
        borderColor="secondary.main"
        borderRadius={8}
        padding={2}
        sx={{
          alignItems: { md: "flex-start", xs: "center" },
          transition: "all 0.5s ease",

          "& > ul > li": {
            position: "relative",
            paddingLeft: "1rem",
          },

          "& > ul > li::before": {
            content: '"•"',
            position: "absolute",
            left: 0,
            color: "#ffffff7d",
          },

          "&:hover": {
            borderColor: "primary.main",
            transition: "all 0.5s ease",
          },
        }}
      >
        <Typography
          variant="h2"
          component="p"
          color="textSecondary"
          sx={{
            textShadow: "1px 1px 20px rgba(81, 139, 241, 1);",
            fontSize: {
              lg: "3.75rem",
              md: "3rem",
              sm: "2.5rem",
              xs: "2rem",
            },
          }}
        >
          0{index}
        </Typography>
        <Typography
          variant="h6"
          component="h4"
          color="textSecondary"
          sx={{
            textAlign: { md: "start", xs: "center" },
          }}
        >
          {title}
        </Typography>

        <ul style={{ color: "#ffffff7d", listStyle: "none" }}>
          {descriptions.map((description, index) => (
            <li key={`${description}-${index}`} style={{ color: "#ffffff7d" }}>
              <Typography variant="caption" color="textPrimary">
                {description}
              </Typography>
            </li>
          ))}
        </ul>
      </Stack>
    </Grid2>
  );
};
